import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import roleService from '../services/RoleService';

const RoleContext = createContext({
  isAdmin: false,
  isRequestor: false,
  canAssignPm: false,
  canApproveQuote: false,
  roleName: "Guest",
  userEmail: "",
  loading: true
});

export const RoleProvider = ({ children }) => {
  const { accounts } = useMsal();
  const [userRole, setUserRole] = useState({
    isAdmin: false,
    isRequestor: false,
    roleName: "Guest",
    userEmail: "",
    loading: true
  });

  useEffect(() => {
    const determineUserRole = async () => {
      if (accounts && accounts.length > 0) {
        const account = accounts[0];
        const email = account.username || "";
        
        console.log("DEBUG - Full account object:", account);
        
        // First check for cached role
        try {
          const cachedRoleStr = localStorage.getItem('odm_user_role');
          if (cachedRoleStr) {
            const cachedRole = JSON.parse(cachedRoleStr);
            // Only use cache if it's for the current user and not expired
            // Caches written before these flags existed lack the field; recompute those
            if (cachedRole.email === email && cachedRole.expires > new Date().getTime()
                && cachedRole.canAssignPm !== undefined && cachedRole.canApproveQuote !== undefined) {
              console.log("DEBUG - Using cached role:", cachedRole);
              setUserRole({
                isAdmin: cachedRole.isAdmin,
                isRequestor: cachedRole.isRequestor,
                canAssignPm: cachedRole.canAssignPm,
                canApproveQuote: cachedRole.canApproveQuote,
                roleName: cachedRole.roleName,
                userEmail: email,
                loading: false
              });
              return;
            } else {
              console.log("DEBUG - Cached role expired or wrong user");
            }
          }
        } catch (error) {
          console.error("Error reading cached role:", error);
        }
        
        // If we get here, we need to calculate the role from groups
        const groups = account.idTokenClaims?.groups || [];
        
        console.log("DEBUG - User groups from token:", groups);
        console.log("DEBUG - Groups array length:", groups.length);
        
        // Calculate role from groups
        const role = roleService.getUserRole(groups);
        
        // Cache the role
        const roleWithMeta = {
          ...role,
          email,
          expires: new Date().getTime() + (4 * 60 * 60 * 1000) // 4 hours
        };
        localStorage.setItem('odm_user_role', JSON.stringify(roleWithMeta));
        
        console.log("DEBUG - Setting final role:", role);
        setUserRole({
          ...role,
          userEmail: email,
          loading: false
        });
      } else {
        console.log("DEBUG - No accounts found, setting Guest role");
        setUserRole({
          isAdmin: false,
          isRequestor: false,
          roleName: "Guest",
          userEmail: "",
          loading: false
        });
      }
    };
    
    determineUserRole();
  }, [accounts]);

  return (
    <RoleContext.Provider value={userRole}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);